import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import NextLink from 'components/NextLink';

import icons from './icons';

import styles from './styles.module.scss';

const GradientCard = ({ url, icon, title, largeTitle, subtitle, theme }) => (
	<NextLink className={cx(styles.card, styles[`theme_${theme}`])} href={url}>
		<div className={styles.content}>
			<div className={styles.icon}>{icons[icon]}</div>
			{subtitle && <div className={styles.subtitle}>{subtitle}</div>}
			<div className={styles.text}>
				{largeTitle && <span className={styles.largeTitle}>{largeTitle}</span>}
				<span className={styles.title}>{title}</span>
			</div>
		</div>
	</NextLink>
);

GradientCard.propTypes = {
	icon: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	title: PropTypes.string.isRequired,
	largeTitle: PropTypes.string,
	theme: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary']),
	url: PropTypes.string
};

GradientCard.defaultProps = {
	theme: 'primary'
};

export default GradientCard;
